<core-ui-dialog-base
  title="{{ 'UPDATE_INFO.TITLE' | translate }}"
  button="{{ 'UPDATE_INFO.BUTTON' | translate }}"
  (buttonClick)="close()"
  [hideCloseIcon]="true"
>
  <p class="update-message">
    <strong>
      {{ 'UPDATE_INFO.MESSAGE_START' | translate }}
      <i>
        {{
          'UPDATE_INFO.MESSAGE_TIMES' | translate: {
            startCalendarDate: (startDateTime | date:'dd.MM.yyyy'),
            startClockTime: (startDateTime | date:'hh:mm a'),
            endClockTime: (endDateTime   | date:'hh:mm a')
          }
        }}
      </i>
      {{ 'UPDATE_INFO.MESSAGE_END' | translate }}
    </strong>
  </p>
</core-ui-dialog-base>
